module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-addons flatpickr",
    class: ( _obj = {}, _obj[("has-addons-" + _vm.alignment)] = _vm.alignment, _obj ),
    attrs: {
      "data-wrap": "true",
      "data-clickOpens": "false"
    }
  }, [_c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "data-input": ""
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17070220"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-datepicker/src/WrapperInput.vue
// module id = 422
// module chunks = 40